import { useMe } from "../auth/me";
import { hasAnyCapability, hasCapability } from "./checks";
import type { Capability } from "./capabilities";

/**
 * Whether the signed-in account holds `capability`. Reads the profile from the query cache (one
 * home for server data), so a refetched `/me` re-renders every caller. `false` while the profile
 * is loading or when nobody is signed in: never optimistic.
 */
export function useCan(capability: Capability): boolean {
  const { data } = useMe();
  return hasCapability(data?.capabilities, capability);
}

/** Whether the signed-in account holds at least one of `capabilities`. */
export function useCanAny(capabilities: readonly Capability[]): boolean {
  const { data } = useMe();
  return hasAnyCapability(data?.capabilities, capabilities);
}
